<template>
    <div>
        <AuthModal />
    </div>
</template>

<script>
    import AuthModal from "../components/modals/AuthModal.vue";
    import axios from "axios";
    export default {
        name: "Login",
        components: {AuthModal},
        created() {
            const self = this;
            axios(process.env.VUE_APP_BACKEND_HOST + '/api/check_session', {
              method: "post",
              withCredentials: true,
              headers : {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function(response) {
                self.isAuth = response.data.status.auth;
                self.isBoss = response.data.status.isBoss;
                if (self.isAuth) {
                  self.$router.push("/");
                }
            })
        }
    }
</script>

<style scoped>

</style>